import * as PIXI from "pixi.js";
import data from "../configs/data";

export class LastDrawnNumbersPanel extends PIXI.Container {

    private readonly DEFAULT_ANCHOR_POINT: any = new PIXI.Point(0.5, 0.5);

    private frameContainer = new PIXI.Container();
    private numbersContainer = new PIXI.Container();
    private numbersSubContainers: Array<PIXI.Container> = [];
    private readonly NUMBERS_POSITIONS_X: Array<number> = [-100, -50, 0, 50, 100];
    private readonly NUMBER_STYLE = {
        fontSize: 32,
        fill: "#fff",
        fontFamily: "BernardMtCondensed",
    };
    private readonly BLACK_COLOR_NUMBERS: Array<number> =
        [2, 4, 6, 8, 10, 11, 13, 15, 17, 20, 22, 24, 26, 28, 29, 31, 33, 35];

    constructor() {
        super();
        this.addChild(this.numbersContainer);
        this.addChild(this.frameContainer);
        this.createAndAddFrame();
    }

    public addLastDrawnNumber(number: number): void {
        const lastNumberContainer: PIXI.Container = new PIXI.Container();
        let lastNumberBackground: PIXI.Sprite;
        const lastNumberText: PIXI.Text = this.createNumber(number);
        if (number === 0) {
            lastNumberBackground = new PIXI.Sprite(PIXI.Texture.fromFrame(data.images.lastDrawnNumbersGreen));
        } else if (this.isBlackNumber(number)) {
            lastNumberBackground = new PIXI.Sprite(PIXI.Texture.fromFrame(data.images.lastDrawnNumbersBlack));
        } else {
            lastNumberBackground = new PIXI.Sprite(PIXI.Texture.fromFrame(data.images.lastDrawnNumbersRed));
        }

        lastNumberBackground.anchor = this.DEFAULT_ANCHOR_POINT;
        lastNumberContainer.addChild(lastNumberBackground);
        lastNumberContainer.addChild(lastNumberText);

        this.numbersContainer.addChild(lastNumberContainer);
        this.numbersSubContainers.unshift(lastNumberContainer);
        for (let i = 0; i < this.numbersSubContainers.length && i < 5; i++) {
            this.numbersSubContainers[i].position.x = this.NUMBERS_POSITIONS_X[i];
        }

        if (this.numbersSubContainers.length > 5) {
            const numberToRemove = this.numbersSubContainers.pop();
            this.numbersContainer.removeChild(numberToRemove);
        }
    }

    private createAndAddFrame(): void {
        const frame = new PIXI.Sprite(PIXI.Texture.fromFrame(data.images.lastDrawnNumbersFrame));
        frame.anchor = this.DEFAULT_ANCHOR_POINT;
        this.frameContainer.addChild(frame);
    }

    private createNumber(number: number): PIXI.Text {
        const numberText = new PIXI.Text("" + number, this.NUMBER_STYLE);
        numberText.anchor = this.DEFAULT_ANCHOR_POINT;
        return numberText;
    }

    private isBlackNumber(number: number): boolean {
        return this.BLACK_COLOR_NUMBERS.indexOf(number) >= 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/userInterface/LastDrawnNumbersPanel.ts